import React from "react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import Select from "react-dropdown-select";
import "./styles.scss";

interface DropdownProps {
  items: { id: number; label: string }[];
  onChange: (items: { id: number; label: string }[]) => void;
  placeholder: string;
  clearable?: boolean;
}

export const Dropdown = (props: DropdownProps): JSX.Element => {
  const { items, onChange, placeholder, clearable } = props;

  const onDropdownChange = (values: { id: number; label: string }[]) => {
    onChange(values);
  };

  return (
    <Select
      valueField="id"
      placeholder={placeholder}
      options={items}
      values={[]}
      dropdownGap={0}
      closeOnSelect
      clearable={clearable}
      onClearAll={() => clearable && onChange([])}
      onChange={(item) => onDropdownChange(item)}
      dropdownHandleRenderer={({ state }) => (
        <span>
          {state.dropdown ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </span>
      )}
    />
  );
};
Dropdown.defaultProps = {
  clearable: false,
};
